import PhoneAuthWithEmailFallback from './PhoneAuthWithEmailFallback';

export default PhoneAuthWithEmailFallback;
